exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-preview[data-v-5472fd9a] {\n  right: 0px;\n  top: 10px;\n}\n", ""]);

// exports
